export type SegmentId = 'onboard' | 'growthA' | 'pressureA' | 'relief' | 'peak' | 'finale';

export interface SegmentTemplate {
  id: SegmentId;
  durationWeight: number;
  spawnIntervalMultiplier: number;
  eliteRatioMultiplier: number;
  gateRows: number;
  gateTrapBias: number;
  weaponBoxChance: number;
}

export const SEGMENT_ORDER: SegmentId[] = [
  'onboard',
  'growthA',
  'pressureA',
  'relief',
  'peak',
  'finale',
];

export const SEGMENT_TEMPLATES: Record<SegmentId, SegmentTemplate> = {
  onboard: {
    id: 'onboard',
    durationWeight: 0.16,
    spawnIntervalMultiplier: 1.25,
    eliteRatioMultiplier: 0,
    gateRows: 1,
    gateTrapBias: -0.06,
    weaponBoxChance: 0.18,
  },
  growthA: {
    id: 'growthA',
    durationWeight: 0.16,
    spawnIntervalMultiplier: 1.1,
    eliteRatioMultiplier: 0.65,
    gateRows: 1,
    gateTrapBias: -0.03,
    weaponBoxChance: 0.32,
  },
  pressureA: {
    id: 'pressureA',
    durationWeight: 0.2,
    spawnIntervalMultiplier: 0.9,
    eliteRatioMultiplier: 1.2,
    gateRows: 1,
    gateTrapBias: 0.05,
    weaponBoxChance: 0.16,
  },
  relief: {
    id: 'relief',
    durationWeight: 0.14,
    spawnIntervalMultiplier: 1.28,
    eliteRatioMultiplier: 0.45,
    gateRows: 1,
    gateTrapBias: -0.08,
    weaponBoxChance: 0.72,
  },
  peak: {
    id: 'peak',
    durationWeight: 0.18,
    spawnIntervalMultiplier: 0.76,
    eliteRatioMultiplier: 1.35,
    gateRows: 1,
    gateTrapBias: 0.08,
    weaponBoxChance: 0.12,
  },
  finale: {
    id: 'finale',
    durationWeight: 0.16,
    spawnIntervalMultiplier: 0.92,
    eliteRatioMultiplier: 1.1,
    gateRows: 1,
    gateTrapBias: 0.04,
    weaponBoxChance: 0.2,
  },
};

export function getOrderedSegmentTemplates(): SegmentTemplate[] {
  return SEGMENT_ORDER.map((id) => SEGMENT_TEMPLATES[id]);
}
